<template>
  <v-slide-y-transition hide-on-leave>
    <v-checkbox
      v-if="inValidatedView"
      v-model="onlyCorrectPredictions"
      hide-details
      label="Mostrar solo QMIs correctos"
    />
  </v-slide-y-transition>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapState } = createNamespacedHelpers("classifier");

export default {
  computed: {
    ...mapState(["showOnlyCorrectPredictions"]),
    inValidatedView() {
      return this.$route.name === "classifier/predictions/validated";
    },
    onlyCorrectPredictions: {
      get() {
        return this.showOnlyCorrectPredictions;
      },
      set(value) {
        this.setShowOnlyCorrectPredictions(value);
      }
    }
  },
  methods: {
    ...mapMutations(["setShowOnlyCorrectPredictions"])
  }
};
</script>